/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAidOptionModelSearchResultModel } from '../../models/medical-aid-option-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface MedicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Params {
  medicalAidId: string;
  medicalAidSchemeId: string;
      body?: SearchRequestModel
}

export function medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost(http: HttpClient, rootUrl: string, params: MedicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidOptionModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost.PATH, 'post');
  if (params) {
    rb.path('medicalAidId', params.medicalAidId, {});
    rb.path('medicalAidSchemeId', params.medicalAidSchemeId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<MedicalAidOptionModelSearchResultModel>;
    })
  );
}

medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost.PATH = '/MedicalAid/{medicalAidId}/{medicalAidSchemeId}/SearchMedicalAidOption';
